<template>
    <div class="center">
        <mt-navbar v-model="select" class="flex">
            <div class="flex flex1">
                    <mt-tab-item id="1" :class="select === '1' ? 'is-selected' : ''">微信</mt-tab-item>	   
                    <mt-tab-item id="2" :class="select === '2' ? 'is-selected' : ''">帖子<div id="tab2"></div></mt-tab-item>	
            </div>
        </mt-navbar>
    </div>
</template>

<script>

export default {
  props: ['channelList', 'selected', 'changeType'],
  watch: {
      select: function(value) {
          console.log(value);
          this.changeType(value)
      }
  },
  name: 'Header',
  data() {
        return {
            select: this.selected,
        }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center {
    width: 100%;
    overflow-y: hidden;
}
.center .mint-tab-item-label {
    font-size: .16rem;
}
.flex {
    justify-content: space-around;
}
.is-select {
    color: #009688;
}
.nav-wrap {
    height: 0.52rem; color: #000;
}
.mint-tab-item {
    color:#000000;
    font-weight:bolder;
}
.is-selected {
    color:#009688 !important;
}
.mint-navbar .mint-tab-item.is-selected {
    border-bottom: 4px solid #009688;
    color: #009688 !important;
    height: 0.07rem;
    margin-bottom: -3px;
    border-radius:3px;
}
hr {
    margin-top: -0.04rem
}
.nav-title {
    margin-top: 0.1rem;
    height: 0.32rem;
    line-height: 0.32rem;
}
ul {
    padding-left: 0px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/userChannelElement/Header.vue